import { useCallback, useEffect, useState } from 'react';
import { ensureWasm } from '../wasm';

export interface WasmReadyState {
  /** wasm init 完了。 盤描画・合法手計算はこれが true になってから。 */
  wasmReady: boolean;
  /** wasm ロード失敗 (= mobile 回線での .wasm 取得失敗等)。 fallback UI を出す。 */
  wasmError: boolean;
  /** 再試行。 `ensureWasm` は失敗時に内部キャッシュを捨てるので再取得できる。 */
  retryWasm: () => void;
}

/**
 * mixed-engine wasm の遅延ロード状態を扱う共通フック。
 *
 * 旧実装は各画面が `void ensureWasm().then(() => setWasmReady(true))` を
 * catch 無しで呼んでおり、 ロード失敗時に「盤は出るがタップ無反応」の静かな
 * 死に方をしていた。 ここで失敗を state 化し、 呼び出し側が再試行 UI を出せる
 * ようにする。
 */
export function useWasmReady(): WasmReadyState {
  const [wasmReady, setWasmReady] = useState(false);
  const [wasmError, setWasmError] = useState(false);

  const retryWasm = useCallback(() => {
    setWasmError(false);
    void ensureWasm()
      .then(() => setWasmReady(true))
      .catch((e) => {
        console.error('wasm load failed', String(e));
        setWasmError(true);
      });
  }, []);

  useEffect(() => {
    retryWasm();
  }, [retryWasm]);

  return { wasmReady, wasmError, retryWasm };
}
